<!-- KYMW1202 掲載媒体設定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">掲載媒体設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <div class="column-list">
            <!-- Pコード -->
            <label class="list-input-title">Pコード</label>
            <div class="list-input-content">
              <input type="text" [value]="model.pCode" readonly [style.width.px]="100" [tabindex]="-1" />
            </div>
            <!-- 商品名 -->
            <label class="list-input-title">商品名</label>
            <div class="list-input-content">
              <input type="text" [value]="model.guideGoodsName" readonly [style.width.px]="316" [tabindex]="-1" />
            </div>
            <!-- 規格名 -->
            <label class="list-input-title">規格名</label>
            <div class="list-input-content">
              <input type="text" [value]="model.guideStandardName" readonly [style.width.px]="316" [tabindex]="-1" />
            </div>
          </div><!-- div column-list END -->
          <!-- FlexGird -->
          <wj-flex-grid #dtg_List [itemsSource]="model.list" [allowDragging]="'None'" horizontalScrollPolicy="off"
            [headersVisibility]="'Column'" [selectionMode]="'Row'" verticalScrollPolicy="on" [autoRowHeights]="true"
             [allowSorting]="false" [tabOrder]="0">
            <!-- column チェックボックス -->
            <wj-flex-grid-column [minWidth]="5" [width]="40" [header]="' '" [binding]="'check'" [align]="'center'" [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
                <input #chk_Header type="checkbox" class="selected headear-checkbox" (click)="$event.stopPropagation();headerCheck();"
                  [tabindex]="-1" />
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
                  [tabindex]="-1" />
              </ng-template>
            </wj-flex-grid-column>
            <!-- column 媒体コード -->
            <wj-flex-grid-column [header]="'媒体コード'" [minWidth]="5" [width]="90" [binding]="'mediumType'"
              [isReadOnly]="true"></wj-flex-grid-column>
            <!-- column 媒体名 -->
            <wj-flex-grid-column [header]="'媒体名'" [minWidth]="5" [width]="270" [binding]="'mediumName'"
              [isReadOnly]="true"></wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div><!-- div contents-area END -->
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="set()" [tabindex]="0" >設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="closeModal()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>